/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ShipmentPackageApiResultModel } from "@tps/App/Store/Reducers/xOrderDetails";

const url = "api/tps/files/IsFilesExists";

export interface LoadShipmentPkgsFilesInfoApiParameter extends ApiParameter {
    orderNumber: string;
    ppsNo: string[];
}

export async function getShipmentPkgsFilesInfo(
    parameter: LoadShipmentPkgsFilesInfoApiParameter,
): Promise<ServiceResult<ShipmentPackageApiResultModel>> {
    try {
        const result = await get<ShipmentPackageApiResultModel>(url, parameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
